export const transactionsColumns = [
  'Tipo de Transação',
  '',
  'Valor',
  'Data',
  'Detalhes da Transação',
];
